import React from 'react';
import { User, Building2, Scale, Landmark, TrendingUp, FileText, Briefcase, HelpCircle } from 'lucide-react';
import { servicesPF, servicesPJ } from '../../data/mock';

const ServicesSection = () => {
  const pfIcons = [Scale, Landmark, TrendingUp];
  const pjIcons = [TrendingUp, FileText, Briefcase];

  const ServiceCard = ({ service, icon: Icon, variant }) => (
    <div className={`p-6 rounded-2xl border transition-all duration-300 hover:shadow-lg ${
      variant === 'pf' 
        ? 'bg-white border-slate-200 hover:border-emerald-200 hover:shadow-emerald-100' 
        : 'bg-slate-800 border-slate-700 hover:border-amber-400/30'
    }`}>
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
        variant === 'pf' ? 'bg-emerald-100' : 'bg-amber-400/10'
      }`}>
        <Icon className={`w-6 h-6 ${
          variant === 'pf' ? 'text-emerald-600' : 'text-amber-400'
        }`} />
      </div>
      
      <h4 className={`text-lg font-bold mb-2 ${
        variant === 'pf' ? 'text-slate-800' : 'text-white'
      }`}>
        {service.title}
      </h4>
      
      <p className={variant === 'pf' ? 'text-slate-600' : 'text-slate-400'}>
        {service.description}
      </p>
    </div>
  );

  return (
    <section id="solucoes" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-4">
            Nossas Soluções
          </span>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Soluções Jurídicas e Financeiras Especializadas
          </h2>
          
          <p className="text-lg text-slate-600 leading-relaxed">
            Atuação técnica e jurídica para regularização de dados de crédito de pessoas físicas e jurídicas.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Pessoa Física */}
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl shadow-slate-200/50 border border-slate-100">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-14 h-14 bg-emerald-600 rounded-2xl flex items-center justify-center">
                <User className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-slate-800">{servicesPF.title}</h3>
                <p className="text-slate-500">Soluções para CPF</p>
              </div>
            </div>
            
            <div className="space-y-4">
              {servicesPF.services.map((service, index) => (
                <ServiceCard 
                  key={index} 
                  service={service} 
                  icon={pfIcons[index]} 
                  variant="pf" 
                />
              ))}
            </div>
          </div>

          {/* Pessoa Jurídica */}
          <div className="bg-slate-900 rounded-3xl p-6 md:p-8 shadow-xl border border-slate-800">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-14 h-14 bg-amber-400 rounded-2xl flex items-center justify-center">
                <Building2 className="w-7 h-7 text-slate-900" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">{servicesPJ.title}</h3>
                <p className="text-slate-400">Soluções para CNPJ</p>
              </div>
            </div>
            
            <div className="space-y-4">
              {servicesPJ.services.map((service, index) => (
                <ServiceCard 
                  key={index} 
                  service={service} 
                  icon={pjIcons[index]} 
                  variant="pj" 
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
